import {RootState} from 'common/src/redux/store';
import {AgentContext} from '../../copilot.types';
import {RouteWithParams} from 'common/src/modules/routing/routing.types';
import routingService from 'common/src/modules/routing/routing.service';
import defaultRouteFormatter from './defaultRouteFormatter';

function currentRouteContext(getState: () => RootState): AgentContext<RouteWithParams | null> {
  return {
    title: 'Current Page',
    getter,
    formatter,
  };

  function getter(): RouteWithParams | null {
    return routingService.getCurrentRouteWithParams();
  }

  function formatter({
    prevContext,
    currentContext: currentRoute,
  }: {
    prevContext: RouteWithParams | null;
    currentContext: RouteWithParams | null;
  }): string | null {
    // If there's no current context (route), return null to skip this context message
    if (!currentRoute) {
      return null;
    }

    const {routeKey} = currentRoute;
    const routeDef = routingService.getRouteDefinition(routeKey);

    if (!routeDef) {
      return null;
    }

    const prefix = prevContext
      ? "The user's location has changed to"
      : "The user's current location";

    const routeFormatter = routeDef.formatter ?? defaultRouteFormatter;

    return `${prefix}: ${routeDef.displayName}
  ${routeFormatter({routeDef, route: currentRoute, getState})}`;
  }
}

export default currentRouteContext;
